import { Box } from "@mantine/core";

export default function Wrapper({
  children,
  className,
}: {
  children: React.ReactNode;
  className: string;
}) {
  return (
    <Box py={"2.5rem"} className={className}>
      {children}
    </Box>
  );
}
